import React, { useEffect, useState } from "react";

const StreamComponent = () => {
  useEffect(() => {
    navigator.mediaDevices
      .getUserMedia({ video: true }) // You can also request audio if needed
      .then((mediaStream) => {
        // Success: set the stream
        console.log("ok");
      })
      .catch((err) => {
        // Error: handle permission denial or other errors
        console.log(`Error accessing camera: ${err.message}`);
      });
  }, []);
  return (
    <div>
      <iframe
        src="https://94.237.62.226:8501/"
        width="100%"
        height="360px"
        frameBorder="0"
        allow="camera; microphone"
        allowFullScreen
        title="Streamed Content"
      />
    </div>
  );
};

export default StreamComponent;
